import React from 'react'
import injectSheet from 'react-jss'
import styles from './comment-entry.styles'
import { Cell } from 'pobble-components/dist/table'
import CircleStatus from 'pobble-components/dist/circle-status'
import Tooltip from 'pobble-components/dist/tooltip'
import ContextMenu from './context-menu/context-menu.container'

const CommentEntry = ({ classes, date, comment, status, id }) => (
  <tr>
    <Cell className={classes.commentCell}>{date}</Cell>
    <Cell>{comment}</Cell>
    <Cell className={classes.statusCell}>
      <Tooltip
        content={
          status === 'pending' ? 'Pending' : status ? 'Approved' : 'Declined'
        }>
        <CircleStatus status={status} />
      </Tooltip>
    </Cell>
    <Cell>
      <ContextMenu id={id} />
    </Cell>
  </tr>
)

export default injectSheet(styles)(CommentEntry)
